<template>
  <!-- 2026-09-03：全屏维护页统一蓝迪云蓝色主题，并安全展示超级管理员配置的纯文本说明。 -->
  <main class="maintenance-page" role="status" aria-live="polite">
    <div class="maintenance-brand">
      <img src="@/assets/images/logo-dark.png" alt="蓝迪云">
      <span>蓝迪云</span>
    </div>
    <section class="maintenance-card">
      <div class="maintenance-icon" aria-hidden="true">
        <ToolOutlined />
      </div>
      <div class="maintenance-tag"><span></span> 服务升级中</div>
      <h1>{{ config.title }}</h1>
      <p>{{ config.message }}</p>
      <a-button class="refresh-button" :loading="checking" @click="$emit('refresh')">
        重新检查
      </a-button>
      <!-- 2026-09-08：普通管理账号通过独立测试入口验证，不借用超级管理员应急放行。 -->
      <a-button class="refresh-button" style="margin-left:12px" @click="$emit('tester-login')">测试人员入口</a-button>
      <div class="maintenance-footnote">维护完成后页面将自动恢复，无需重复操作。</div>
    </section>
    <div class="maintenance-decoration decoration-one"></div>
    <div class="maintenance-decoration decoration-two"></div>
  </main>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { ToolOutlined } from '@ant-design/icons-vue'
import { SystemMaintenanceConfig } from '@/utils/maintenance'

export default defineComponent({
  name: 'MaintenanceScreen',
  components: { ToolOutlined },
  props: {
    config: {
      type: Object as PropType<SystemMaintenanceConfig>,
      required: true
    },
    checking: {
      type: Boolean,
      default: false
    }
  },
  emits: ['refresh', 'tester-login']
})
</script>

<style lang="scss" scoped>
.maintenance-page {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 320px;
  padding: 88px 24px 40px;
  overflow: hidden;
  color: #172033;
  background:
    radial-gradient(circle at 12% 15%, rgba(var(--activeColorRGB,24,144,255),.16), transparent 31%),
    radial-gradient(circle at 90% 88%, rgba(9, 109, 217, .14), transparent 28%),
    linear-gradient(145deg, #f8fbff 0%, #edf6ff 55%, #f7fbff 100%);
}
.maintenance-brand {
  position: absolute;
  top: 28px;
  left: 38px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 11px;
  color: #101828;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 1px;
  img {
    width: 36px;
    height: 36px;
    object-fit: contain;
  }
}
.maintenance-card {
  position: relative;
  z-index: 2;
  width: min(650px, 100%);
  padding: 54px 58px 46px;
  border: 1px solid rgba(var(--activeColorRGB,24,144,255),.16);
  border-radius: 22px;
  text-align: center;
  background: rgba(255, 255, 255, .94);
  box-shadow: 0 24px 70px rgba(27, 92, 160, .14);
  backdrop-filter: blur(12px);
  h1 {
    margin: 18px 0 15px;
    color: #101828;
    font-size: 34px;
    font-weight: 700;
    line-height: 1.35;
  }
  p {
    max-width: 510px;
    margin: 0 auto;
    color: #475467;
    font-size: 16px;
    line-height: 1.9;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
}
.maintenance-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 74px;
  height: 74px;
  margin: 0 auto;
  border-radius: 22px;
  color: #ffffff;
  font-size: 34px;
  background: linear-gradient(145deg, #1689f5, #096dd9);
  box-shadow: 0 13px 30px rgba(9, 109, 217, .26);
}
.maintenance-tag {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-top: 26px;
  padding: 6px 13px;
  border-radius: 999px;
  color: var(--admin-skin-deep,#096dd9);
  font-size: 13px;
  font-weight: 600;
  background: var(--admin-skin-soft,#eaf4ff);
  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--activeColor,#1890ff);
    box-shadow: 0 0 0 5px rgba(var(--activeColorRGB,24,144,255),.12);
  }
}
.refresh-button {
  height: 38px;
  margin-top: 28px;
  padding: 0 24px;
  border-color: var(--activeColor,#1890ff);
  border-radius: 8px;
  color: var(--admin-skin-deep,#096dd9);
}
.maintenance-footnote {
  margin-top: 18px;
  color: #98a2b3;
  font-size: 12px;
}
.maintenance-decoration {
  position: absolute;
  border: 1px solid rgba(var(--activeColorRGB,24,144,255),.16);
  border-radius: 50%;
}
.decoration-one {
  top: -180px;
  right: -120px;
  width: 430px;
  height: 430px;
}
.decoration-two {
  bottom: -230px;
  left: -120px;
  width: 520px;
  height: 520px;
}
@media (max-width: 600px) {
  .maintenance-page { padding: 72px 16px 28px; }
  .maintenance-brand { top: 20px; left: 22px; }
  .maintenance-card { padding: 40px 24px 34px; }
  .maintenance-card h1 { font-size: 28px; }
}
</style>
